import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HiFingerPrint, HiMenu, HiOutlineChatAlt2, HiOutlineUsers } from "react-icons/hi";
import classnames from "classnames";

import { UserContext } from "../../context/UserContext";
import { getVenueTypeConfig } from "../../lib/consts/venueTypes";

const MOBILE_NAV = [
  {
    key: "menu",
    label: "Menu",
    type: "menu",
    icon: <HiMenu />,
    ariaLabel: "Abrir menu",
  },
  {
    key: "ai",
    label: "Agente IA",
    type: "route",
    path: "/asistente-ia",
    icon: <HiOutlineChatAlt2 />,
  },
  {
    key: "customers",
    label: "Socios",
    type: "route",
    path: "/customers",
    icon: <HiOutlineUsers />,
    legacySrText: "Dispensario",
  },
  {
    key: "control",
    label: "Entradas",
    type: "route",
    path: "/control",
    icon: <HiFingerPrint />,
    legacySrText: "Panel",
  },
];

export default function MobileBottomNav({ onMenuClick, visible = true }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [, , , , , , , accessPrivileges, , , , venueType] = useContext(UserContext);
  const venueConfig = getVenueTypeConfig(venueType);
  const items = MOBILE_NAV.filter((item) => {
    if (item.key === "customers") return venueConfig.showMembers;
    return true;
  });

  if (!accessPrivileges) return null;

  // Una sola fila horizontal: los 4 ítems en línea (flex-nowrap). Dentro de cada uno: icono arriba, texto abajo.
  const itemBase =
    "flex h-14 w-full min-w-0 flex-col items-center justify-center gap-0.5 px-0.5 text-[11px] font-medium";

  return (
    <nav
      className={classnames(
        "md:hidden fixed bottom-0 left-0 right-0 z-[100] border-t border-gray-200 bg-white/95 backdrop-blur pb-[max(0.25rem,env(safe-area-inset-bottom))] will-change-transform",
        !visible && "pointer-events-none"
      )}
      style={{
        transform: visible ? "translate3d(0,0,0)" : "translate3d(0,100%,0)",
        transition: "transform 0.3s ease-out",
      }}
      aria-label="Navegacion movil"
      aria-hidden={!visible}
    >
      <ul className="flex w-full flex-row flex-nowrap items-stretch">
        {items.map((item) => {
          const isActive = item.type === "route" && location.pathname === item.path;
          return (
            <li key={item.key} className="flex min-w-0 flex-1 basis-0 flex-col">
              <button
                type="button"
                onClick={() => {
                  if (item.type === "menu") {
                    onMenuClick?.();
                    return;
                  }
                  navigate(item.path);
                }}
                aria-current={isActive ? "page" : undefined}
                aria-label={item.ariaLabel}
                className={classnames(
                  itemBase,
                  isActive ? "text-[var(--sidebar-active)] font-medium" : "text-gray-600"
                )}
              >
                <span className="shrink-0 text-lg leading-none">{item.icon}</span>
                <span className="max-w-full truncate text-center leading-tight">
                  {item.label}
                  {item.legacySrText ? <span className="sr-only"> {item.legacySrText}</span> : null}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
